import { Box } from '@material-ui/core';
import styled from 'styled-components';

export const SideBarCard = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  background-color: white;
  overflow: hidden;
  border-radius: 10px;
  white-space: nowrap;
  box-sizing: border-box;
  max-height: 200px;
  overflow-y: auto;
`;
